// REACT
import React, {
	useContext,
	Dispatch,
	SetStateAction,
	useState,
	useEffect,
	useCallback,
	RefObject,
	useRef,
} from 'react'

// ESTILOS
import Styles from './Services.module.css'

// CONTEXTO
import CloseButton from 'Components/CloseButton/CloseButton'
import ServicesContact from './ServicesContact'
import MainContext from 'Context/MainContext'

const ServicesSliders: React.FC = () => {
	// STRINGS
	const { slides } = useContext(MainContext).lang.services

	// ESTADO
	const [slideN, setSlide]: [number, Dispatch<SetStateAction<number>>] = useState(0)

	// REFERENCIAS
	const tourRef: RefObject<HTMLDivElement> = useRef(null)
	const eventsRef: RefObject<HTMLDivElement> = useRef(null)
	const headerSects: RefObject<HTMLDivElement>[] = [tourRef, eventsRef]

	// CHANGE HEADERS
	const toggleHeader = (toggle: boolean, mode: boolean) => {
		// SELECCIONAR HEADERS
		const first: HTMLDivElement | null = headerSects[toggle ? 0 : 1].current
		const second: HTMLDivElement | null = headerSects[toggle ? 1 : 0].current

		if (first && second) {
			// SELECCIONAR CHILDREN
			const contactS: HTMLDivElement | null = first.childNodes[1] as HTMLDivElement
			const closeS: HTMLDivElement | null = first.childNodes[2] as HTMLDivElement
			const title: HTMLHeadingElement | null = first.childNodes[0] as HTMLHeadingElement
			const titleDot: HTMLSpanElement | null = title.childNodes[0] as HTMLSpanElement
			const titleHelper: HTMLSpanElement | null = title.childNodes[2] as HTMLSpanElement

			// RESPONSIVE
			first.style.gridTemplateColumns =
				window.innerWidth > 750 ? (mode ? 'auto auto auto' : 'auto') : mode ? 'auto auto' : 'auto'
			if (window.innerWidth <= 750) first.style.gridTemplateRows = !mode ? 'auto' : 'auto 100px'

			// CAMBIAR DIMENSIONES CON RESPONSIVE
			first.style.height = window.innerWidth <= 750 ? (mode ? '250px' : '250px') : 'unset'
			first.style.width = window.innerWidth <= 750 ? '100vw' : mode ? '100vw' : '50%'
			first.style.zIndex = mode ? '4' : '1'
			second.style.height = window.innerWidth <= 750 ? (mode ? '0' : '250px') : 'unset'
			second.style.width = window.innerWidth > 750 ? (mode ? '0' : '50%') : 'unset'

			// CAMBIAR CHILDREN
			contactS.style.display = mode ? 'grid' : 'none'
			closeS.style.display = mode ? 'flex' : 'none'
			titleDot.style.display = mode ? 'none' : 'inline-block'
			title.style.textAlign = mode ? 'left' : 'center'

			// CAMBIAR ELEMENTOS SECUNDARIOS
			if (titleHelper) titleHelper.style.display = mode ? 'block' : 'none'
			title.classList.toggle(Styles.borderTitle)
		}
	}

	// ABRIR/CERRAR TOUR
	const openTour = () => toggleHeader(true, true)
	const hideTour = () => toggleHeader(true, false)

	// ABRIR/CERRAR EVENTS
	const openEvents = () => toggleHeader(false, true)
	const hideEvents = () => toggleHeader(false, false)

	// AUMENTAR SLIDE
	const nextSlide = useCallback(() => {
		// LOOP
		let nSlide: number = slideN + 1
		if (nSlide > 2) nSlide = 0

		// ACTUALIZAR ESTADO
		setSlide(nSlide)
	}, [slideN])

	// DISMINUIR SLIDE
	const prevSlide = useCallback(() => {
		// LOOP
		let nSlide: number = slideN - 1
		if (nSlide < 0) nSlide = 2

		// ACTUALIZAR ESTADO
		setSlide(nSlide)
	}, [slideN])

	// AUTO
	useEffect(() => {
		// CREAR INTERVALO
		const interval = setInterval(() => nextSlide(), 5000)

		// ELIMINAR INTERVALO
		return () => clearInterval(interval)
	}, [nextSlide])

	return (
		<section className={Styles.page}>
			<div className={Styles.headerTour}>
				<div ref={tourRef} className={`${Styles.slideHeader} headerSect`}>
					<h1 onClick={openTour} className={Styles.slideTitle}>
						<span className={Styles.dot}>></span>
						{slides.tourTitle}
					</h1>
					<ServicesContact />
					<CloseButton
						style={{ transform: 'scale(0.7)', display: 'none', justifySelf: 'flex-end' }}
						action={hideTour}
					/>
				</div>
				<div ref={eventsRef} className={`${Styles.slideHeader} headerSect`}>
					<h1 onClick={openEvents} className={Styles.slideTitle}>
						<span className={Styles.dot}>></span>
						{slides.eventTitle}
						<span className={Styles.eventHelper}>{slides.eventHelper}</span>
					</h1>
					<ServicesContact />
					<CloseButton
						style={{ transform: 'scale(0.7)', display: 'none', justifySelf: 'flex-end' }}
						action={hideEvents}
					/>
				</div>
			</div>

			<div className={Styles.opinionsContainer}>
				<h1>{slides.opinionsText}</h1>
				<div className={Styles.opinionContent}>
					<button aria-label='Previous' className={Styles.opinionController} onClick={prevSlide}>
						<i className='lni lni-chevron-left' />
					</button>
					<div className={Styles.opinionsBox}>
						<div
							className={Styles.opinionSlide}
							style={{ transform: `translateX(-${slideN * 33.33}%)` }}>
							{slides.opinions.map((opinion: IOpinion, key: number) => (
								<div key={key} className={Styles.opinion}>
									<img
										className={Styles.opinionPic}
										src={require(`../../${opinion.pic}`)}
										alt={`${opinion.name} Profile`}
									/>
									<h2 className={Styles.opinionTitle}>{opinion.name}</h2>
									<p className={Styles.opinionText}>{opinion.text}</p>
									<ul className={Styles.stars}>
										<li>
											<i className='lni lni-star-filled' />
										</li>
										<li>
											<i className='lni lni-star-filled' />
										</li>
										<li>
											<i className='lni lni-star-filled' />
										</li>
										<li>
											<i className='lni lni-star-filled' />
										</li>
										<li>
											<i className='lni lni-star-filled' />
										</li>
									</ul>
								</div>
							))}
						</div>
					</div>
					<button aria-label='Next' className={Styles.opinionController} onClick={nextSlide}>
						<i className='lni lni-chevron-right' />
					</button>
				</div>
			</div>
		</section>
	)
}

export default ServicesSliders
